import { HTMLAttributes } from "react";
import { Loader2 } from "lucide-react";
import styles from "./Spinner.module.css";
import { cx } from "../utils";

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
    size?: "xs" | "sm" | "md" | "lg";
    tone?: "default" | "accent";
}

const sizeClasses = {
    xs: styles.sizeXs,
    sm: styles.sizeSm,
    md: styles.sizeMd,
    lg: styles.sizeLg
};

export const Spinner = ({ size = "md", tone = "default", className, ...props }: SpinnerProps) => (
    <span className={cx(styles.spinner, tone === "accent" && styles.toneAccent, className)} {...props}>
        <Loader2 className={cx(styles.icon, sizeClasses[size])} aria-hidden="true" />
    </span>
);
